module.exports = __webpack_public_path__ + "static/media/Path 3569.7ae13b51.svg";